import { useMutation, useQuery } from "@tanstack/react-query";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useHistory, useParams } from "react-router-dom";

//Components
import Questions from "../../../components/Questions/Questions";
import SurveyHeader from "../../../components/Survey/SurveyHeader/SurveyHeader";
import SurveyItems from "../../../components/Survey/SurveyItems/SurveyItems";
import SurveyControls from "../../../components/Survey/SurveyControls/SurveyControls";

//Redux
import {
  DeleteQuestions,
  EditSurveyDescription,
  EditSurveyTitle,
  MoveQuestions,
  SetSelectedQuestions,
  SetSurvey,
  SurveyAddItemSpecifixIndex,
} from "../../../redux/slice/SurveySlice/SurveySlice";
//APIs
import { getSurvey, editSurvey } from "../../../services/ApiServices";
import Error from "../../Error/Error";
import Layout from "../../../layout/Layout";
import Loader from "../../../components/Loader/Loader";

export default function EditSurvey() {
  const { id } = useParams();
  const Survey = useSelector((state) => state.Survey);
  const dispatch = useDispatch();
  const history = useHistory();

  const SaveSurveyQuestions = () => {
    mutation.mutate({ id: id, value: Survey.Survey });
  };

  const mutation = useMutation(editSurvey, {
    onSuccess: (value) => {
      toast.success(
        "Anket değişikliğiniz başarılı bir şekilde kayıt edilmiştir."
      );
      refetch();
      history.push("/home");
    },
    onError: (error) => {
      toast.error("Anket değişiliginiz kayıt edilirken hata oluştu.");
      refetch();
      return <Error error={error.message} code={error.request.status} />;
    },
  });

  function ListPushSpesific(type, index) {
    switch (type) {
      case "multi":
        dispatch(
          SurveyAddItemSpecifixIndex({
            item: {
              title: "Başlık 1",
              question_type: "multi",
              required: false,
              options: ["Seçenek 1", "Seçenek 2", "Seçenek 3", "Seçenek 4"],
            },
            index: index,
          })
        );
        break;
      case "single":
        dispatch(
          SurveyAddItemSpecifixIndex({
            item: {
              title: "Başlık 1",
              question_type: "single",
              required: false,
              options: ["Seçenek 1", "Seçenek 2", "Seçenek 3", "Seçenek 4"],
            },
            index: index,
          })
        );
        break;
      case "input":
        dispatch(
          SurveyAddItemSpecifixIndex({
            item: {
              title: "Başlık 1",
              question_type: "input",
              required: false,
            },
            index: index,
          })
        );
        break;

      case "score":
        dispatch(
          SurveyAddItemSpecifixIndex({
            item: {
              title: "Başlık 1",
              question_type: "score",
              required: false,
            },
            index: index,
          })
        );
      case "boolean":
        dispatch(
          SurveyAddItemSpecifixIndex({
            item: {
              title: "Başlık 1",
              question_type: "boolean",
              required: false,
              emoji: false,
              options: ["Evet","Hayır"],
            },
            index: index,
          })
        );
        break;
      default:
        break;
    }
  }

  function SetSelectedItem(index) {
    dispatch(SetSelectedQuestions(index));
  }

  const { isLoading, error, data, refetch } = useQuery(
    ["getSurvey"],
    getSurvey.bind(null, id),
    {
      refetchOnWindowFocus: false,
      cacheTime: 0,
      onSuccess: (value) => {
        dispatch(SetSurvey(value.data));
      },
    }
  );

  if (isLoading) return <Loader />;

  if (error)
    return (
      <Error
        error={error.message}
        code={error.request.status}
        text={"Giriş Ekranına Geri Dön "}
        historylink={"/"}
      />
    );

  return (
    <Layout>
      <div className="w-full min-h-[calc(100vh-50px)] flex items-center  bg-gray-100 flex-col transition-all">
        <div
          className={
            Survey.Survey.questions.length > 0
              ? " px-2 sm:px-4 py-2.5 md:fixed md:inline  z-20 top-14 right-16 border-b border-gray-200 transition-all delay-500 mt-0"
              : "hidden transition-shadow top-0 -mt-10"
          }
        >
          <SurveyControls
            SaveClick={() => SaveSurveyQuestions()}
            PreviewClick={() => console.log(Survey.Survey)}
          />
        </div>
        <SurveyHeader
          OnChangeTitle={(title) => dispatch(EditSurveyTitle(title))}
          OnChangeDescription={(description) =>
            dispatch(EditSurveyDescription(description))
          }
          title={Survey.Survey.title}
          description={Survey.Survey.description}
          headerBackgroundPath={Survey.Survey.headerBackgroundImagePath}
          footerBackgroundPath={Survey.Survey.footerBackgroundImagePath}
        />
        {Survey.Survey.questions.map((element, index) => {
          return (
            <div key={index}>
              <SurveyItems
                key={index}
                index={index}
                onEdit={true}
                children={
                  <Questions
                    index={index}
                    id={element._id}
                    type={element.question_type}
                    title={element.title}
                    description={element.description}
                    options={element.options}
                    emoji={element.emoji}
                    firstEmojiUrl = {element.firstEmojiUrl}
                    secondEmojiUrl={element.secondEmojiUrl}
                    required={element.required}
                    onEdit={true}
                  />
                }
                OnClick={() => SetSelectedItem(index)}
                DeleteQuestions={() => dispatch(DeleteQuestions(index))}
                MoveQuestionsUp={() =>
                  dispatch(MoveQuestions({ index: index, newindex: index - 1 }))
                }
                MoveQuestionsDown={() =>
                  dispatch(MoveQuestions({ index: index, newindex: index + 1 }))
                }
                SurveyAddItem={(value) => ListPushSpesific(value, index + 1)}
              />
            </div>
          );
        })}
      </div>
    </Layout>
  );
}
